/* eslint max-len: ["error", { "code": 130, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {changeTheme, changeLocale} from '../actions';
import * as themeTypes from '../constants/ThemeTypes';
import {Link} from 'react-router-dom';
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import ActionHome from 'material-ui/svg-icons/action/home';
import AccountBox from 'material-ui/svg-icons/action/account-box';
import Assignment from 'material-ui/svg-icons/action/assignment';
import ContactMail from 'material-ui/svg-icons/communication/contact-mail';
import Divider from 'material-ui/Divider';
import IconMenuRight from './IconMenuRight';
import DrawerLogo from './DrawerLogo';
import TitleAppBar from './TitleAppBar';
import windowSize from 'react-window-size';
import {requestLogout} from '../actions/login';
import {white} from 'material-ui/styles/colors';

import '../css/Header.css';

class Header extends Component {
    static propTypes = {
        login: PropTypes.object.isRequired,
        locale: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        windowWidth: PropTypes.number.isRequired,
        changeTheme: PropTypes.func.isRequired,
        changeLocale: PropTypes.func.isRequired,
        logout: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {open: false};
    }

    handleToggle = () => this.setState({open: !this.state.open});
    handleClose = () => this.setState({open: false});
    handleChangeTheme = () => {
        this.props.changeTheme(this.props.theme.indexTheme === themeTypes.LIGHT_THEME?
                                themeTypes.DARK_THEME : themeTypes.LIGHT_THEME);
        this.setState({open: false});
    };

    render() {
        return (
            <Fragment>
                <AppBar
                    title = {<TitleAppBar/>}
                    iconElementRight={<IconMenuRight locale={this.props.locale}
                                                     login={this.props.login}
                                                     doLogout={() => this.props.logout()}
                                                     changeLocale={(locale) => this.props.changeLocale(locale)}/>
                    }
                    onLeftIconButtonClick={() => this.handleToggle()}
                    titleStyle={{
                        paddingTop: '10px',
                        height: '54px',
                    }}
                    style={{position: 'fixed', top: '0', backgroundColor: white}}
                    showMenuIconButton={false}
                />
                <Drawer
                    docked={false}
                    open={this.state.open}
                    onRequestChange={(open) => this.setState({open})}
                    width={280}
                >
                    <DrawerLogo/>
                    <Divider/>
                    <Link to="/" className="item-menu-link">
                        <MenuItem leftIcon={<ActionHome/>} onClick={this.handleClose}>{this.props.locale.home}</MenuItem>
                    </Link>
                    <Link to="/about-us" className="item-menu-link">
                        <MenuItem leftIcon={<AccountBox/>} onClick={this.handleClose}>{this.props.locale.about}</MenuItem>
                    </Link>
                    <Link to="/feed" className="item-menu-link">
                        <MenuItem leftIcon={<Assignment/>} onClick={this.handleClose}>{this.props.locale.feed}</MenuItem>
                    </Link>
                    <Link to="/contact-us" className="item-menu-link">
                        <MenuItem leftIcon={<ContactMail/>} onClick={this.handleClose}>{this.props.locale.contact}</MenuItem>
                    </Link>
                </Drawer>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    login: state.login,
    theme: state.theme,
    locale: state.locale.locale,
});

const mapDispatchToProps = {
    changeTheme: changeTheme,
    changeLocale: changeLocale,
    logout: requestLogout,
};

export default windowSize(connect(
    mapStateToProps,
    mapDispatchToProps
)(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js